import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, LogOut, User } from 'lucide-react';

function Layout({ children, onLogout }) {
    const location = useLocation();
    const isHome = location.pathname === '/';
    const isProfile = location.pathname === '/profile';

    return (
        <div className="min-h-screen bg-gray-50/50 font-sans text-gray-900 flex flex-col">
            {/* Header fixe */}
            <header className="sticky top-0 z-40 w-full bg-white border-b border-gray-200/80 backdrop-blur-xl supports-[backdrop-filter]:bg-white/80">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        {/* Logo & Brand */}
                        <div className="flex items-center gap-3">
                            <div className="bg-gradient-to-br from-blue-600 to-indigo-600 text-white p-2 rounded-lg shadow-lg shadow-blue-600/20">
                                <HomeIcon className="w-5 h-5" />
                            </div>
                            <div className="flex flex-col">
                                <span className="text-lg font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-600">
                                    Villas Gaia
                                </span>
                                <span className="text-xs text-gray-500 font-medium">Gestionnaire d'annonces</span>
                            </div>
                        </div>

                        {/* Desktop Nav */}
                        <nav className="hidden md:flex items-center gap-1 p-1 bg-gray-100/50 rounded-full border border-gray-200">
                            <Link
                                to="/"
                                className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all ${
                                    isHome
                                        ? 'bg-white text-blue-700 shadow-sm ring-1 ring-gray-200'
                                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200/50'
                                }`}
                            >
                                Annonces
                            </Link>
                            <Link
                                to="/profile"
                                className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all ${
                                    isProfile
                                        ? 'bg-white text-blue-700 shadow-sm ring-1 ring-gray-200'
                                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200/50'
                                }`}
                            >
                                Profil
                            </Link>
                        </nav>

                        {/* User Profile */}
                        <div className="flex items-center gap-4">
                            <div className="hidden md:flex flex-col items-end">
                                <span className="text-sm font-medium text-gray-700">Admin VillaGaia</span>
                                <span className="text-xs text-gray-500">admin@villagaia.com</span>
                            </div>
                            <button className="p-1.5 rounded-full bg-gray-100 border border-gray-200 text-gray-600 hover:bg-gray-200 transition-colors">
                                <User className="w-5 h-5" />
                            </button>
                            <div className="h-8 w-px bg-gray-200 mx-1 hidden md:block"></div>
                            <button
                                className="p-2 text-gray-400 hover:text-red-600 transition-colors"
                                title="Déconnexion"
                                onClick={onLogout}
                            >
                                <LogOut className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Contenu animé */}
            <main className="flex-1 relative overflow-hidden">
                {children}
            </main>

            {/* Footer fixe */}
            <footer className="border-t border-gray-200 bg-white py-6">
                <div className="max-w-7xl mx-auto px-4 text-center">
                    <p className="text-sm text-gray-500">
                        © {new Date().getFullYear()} Villas Gaia. Tous droits réservés. | par{' '}
                        <a href="https://yodlynci.com" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 hover:underline">
                            Yod Lynci
                        </a>
                    </p>
                </div>
            </footer>
        </div>
    );
}

export default Layout;
